import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import MobileTicketList from "./MobileTicketList";
import MobileAddNewTicket from "../ticket/newTicket/mobile/MobileAddNewTicket";
import { getActiveTickets, getCompletedTickets } from "../../../../redux/slices/tickets";

export default function MobileTicketsView() {

  const [isTicketsLoaded, setIsTicketsLoaded] = useState(null);
  const [searchParams] = useSearchParams();
  const isAddingNewTicket = useSelector((state) => state.tickets.isAddingNewTicket);

  const status = searchParams.get('status');

  const start = searchParams.get('start');
  const end = searchParams.get('end');

  const dispatch = useDispatch();

  useEffect(() => {
    setIsTicketsLoaded(false);
    if(status === "complete" && start && end) {
      dispatch(getCompletedTickets({ startDate: start, endDate: end })).then(() => setIsTicketsLoaded(true));
    }
  }, [start, end, status]);

  useEffect(() => {
    if(status === "active") {
      setIsTicketsLoaded(false);
      dispatch(getActiveTickets()).then(() => {
        setIsTicketsLoaded(true);
      });
    }
  }, [status]);

  return <Box sx={{height: '100%', padding: 0}}>
    {isAddingNewTicket ? <MobileAddNewTicket/> : <MobileTicketList isTicketsLoaded={isTicketsLoaded} />}
  </Box>
}